// @flow
import * as React from 'react';

/* eslint-disable react/no-unused-prop-types */
type Props = {
    children?: React.Node,
    className?: string,
    component?: React.ElementType,
    href?: string,
    refProp?: string,
    title: string,
};
/* eslint-enable react/no-unused-prop-types */

// eslint-disable-next-line no-unused-vars
const Tab = (props: Props) => <i />;

export default Tab;
